import { parseIsoDateTime } from '@/shared/utils/date';
import { utcDifferenceInDays, utcToday } from '@/shared/utils/utc';

export const classes = (...names: (0 | string | false | null | undefined)[]) =>
  names
    .filter((name) => typeof name === 'string')
    .map((name) => (name as string).trim())
    .filter((name) => name)
    .join(' ');

export const dueDateClass = (due: Date | string | null | undefined): string => {
  if (due) {
    if (typeof due === 'string') {
      due = parseIsoDateTime(due);
    }

    if (due) {
      const days = utcDifferenceInDays(due, utcToday());

      if (days <= 0) {
        return 'due';
      } else if (days <= 30) {
        return 'due-soon';
      }
    }
  }

  return '';
};
